import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';

const FeedbackForm = ({ handleSubmit }) => {
    const [feedbackData, setFeedbackData] = useState({
        username: '',
        email: '',
        feedback: '',
    });

    useEffect(() => {
        try {
            const storedProfile = localStorage.getItem('profile');
            const username = localStorage.getItem('username');
            const email = localStorage.getItem('email');

            const parsedProfile = storedProfile ? JSON.parse(storedProfile) : {};
            const updatedData = {
                ...feedbackData,
                username: username || parsedProfile.username || '',
                email: email || parsedProfile.email || '',
            };

            setFeedbackData(updatedData);
            console.log('Loaded from localStorage:', updatedData);
        } catch (error) {
            console.error('Error loading user data from localStorage:', error);
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const updatedData = { ...feedbackData, [name]: value };
        setFeedbackData(updatedData);
        console.log('Updated feedbackData:', updatedData);
    };

    const onSubmit = (e) => {
        e.preventDefault();
        console.log('Submitting:', feedbackData);
        handleSubmit(feedbackData);
    };

    return (
        <Form onSubmit={onSubmit}>
            <Form.Group controlId="feedback">
                <Form.Label>Feedback</Form.Label>
                <Form.Control
                    as="textarea"
                    name="feedback"
                    value={feedbackData.feedback}
                    onChange={handleChange}
                    required
                />
            </Form.Group>
            <Button variant="primary" type="submit" className="mt-3">
                Submit
            </Button>
        </Form>
    );
};

export default FeedbackForm;
